<template>
  <div v-if="!loading && !viewIsLoading">
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.sap_code')">
          <b-form-input
            v-model="item.sap_code"
            name="sap_code"
            type="text"
            required
            placeholder="1234"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.aim_code')">
          <b-form-input
            v-model="item.aim_code"
            name="aim_code"
            type="text"
            placeholder="1234"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.chnm_code')">
          <b-form-input
            v-model="item.chnm_code"
            name="chnm_code"
            type="text"
            placeholder="1234"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.spms_code')">
          <b-form-input
            v-model="item.spms_code"
            name="spms_code"
            type="text"
            placeholder="1234"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group :label="$t('field.commercial_name')">
      <b-form-input
        v-model="item.commercial_name"
        name="commercial_name"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.dosage')">
          <b-form-input
            v-model="item.dosage"
            name="dosage"
            type="text"
            required
            placeholder="1mg"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.dosage_form')">
          <multi-select
            v-model="dosageForm"
            :multiple="false"
            :options="dosageForms"
            :allow-empty="false"
            :searchable="true"
            :placeholder="$t('actions.pick_dosage_form')"
            :show-labels="false"
            label="label"
            @input="updateDosageForm"
          >
            <span slot="noOptions">{{ $t("messages.no_results") }}</span>
            <span slot="noResult">{{ $t("messages.no_results") }}</span>
          </multi-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group :label="$t('field.name')">
      <b-form-input
        v-model="item.name"
        name="name"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-form-group :label="$t('field.presentation')">
      <b-form-input
        v-model="item.presentation"
        name="presentation"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-form-group :label="$t('field.conservation_conditions')">
      <b-form-input
        v-model="item.conservation_conditions"
        name="conservation_conditions"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.price_unit')">
          <b-input-group append="€">
            <b-form-input
              v-model="item.price_unit"
              name="price_unit"
              type="number"
              required
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.tax')">
          <multi-select
            v-model="tax"
            :multiple="false"
            :options="taxes"
            :allow-empty="true"
            :searchable="true"
            :placeholder="$t('actions.pick_tax')"
            :show-labels="false"
            label="label"
            track-by="id"
            @input="updateTax"
          >
            <span slot="noOptions">{{ $t("messages.no_results") }}</span>
            <span slot="noResult">{{ $t("messages.no_results") }}</span>
          </multi-select>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.quantity_per_package')">
          <b-input-group>
            <b-form-input
              v-model="item.quantity_per_package"
              name="quantity_per_package"
              type="number"
              required
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.classification')">
          <multi-select
            v-model="classification"
            :multiple="false"
            :options="classifications"
            :allow-empty="false"
            :searchable="true"
            :placeholder="$t('actions.pick_classification')"
            :show-labels="false"
            label="label"
            @input="updateClassification"
          >
            <span slot="noOptions">{{ $t("messages.no_results") }}</span>
            <span slot="noResult">{{ $t("messages.no_results") }}</span>
          </multi-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.authorization_date')">
          <b-form-input
            v-model="item.authorization_date"
            name="authorization_date"
            type="date"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="$t('field.marketing_date')">
          <b-form-input
            v-model="item.marketing_date"
            name="marketing_date"
            type="date"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-checkbox v-model="item.is_generic_drug" switch class="mb-3">
            {{ $t("field.is_generic_drug") }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-checkbox v-model="item.is_marketed" switch class="mb-3">
            {{ $t("field.is_marketed") }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :label="$t('field.license')">
          <b-form-input
            v-model="item.license"
            name="license"
            type="text"
            required
          />
        </b-form-group>
        <b-form-group :label="$t('field.taim')">
          <b-form-input v-model="item.taim" name="taim" type="text" required />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import taxesApi from '@/api/taxes'
import MultiSelect from 'vue-multiselect'
import {
  dosageFormOptions,
  classificationDrugOptions
} from '@/constants/options'

export default {
  props: {
    viewIsLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    MultiSelect
  },
  data: () => ({
    dosageFormOptions,
    classificationDrugOptions,
    loading: true,
    taxesApi,
    taxes: [],
    tax: null,
    classifications: [],
    classification: null,
    dosageForms: [],
    dosageForm: null
  }),
  computed: {
    ...mapGetters({
      item: 'form/fields'
    })
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      await Promise.all([this.getTaxes()])
      this.getClassifications()
      this.getDosageForms()

      this.setTax()
      this.setClassification()
      this.setDosageForm()

      this.loading = false
    },
    async getTaxes() {
      try {
        const response = await this.taxesApi.all()

        if (response && response.data && response.data.list) {
          this.taxes = response.data.list.map(item => ({
            id: item.id,
            label: this.formatPercentageWithSymbol(item.value)
          }))
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }
    },
    setTax() {
      this.tax = this.item.tax_id
        ? this.taxes.find(item => item.id === this.item.tax_id)
        : null

      if (this.tax === undefined) {
        this.$toasted.error(
          this.$t('messages.not_found_foreign', {
            field: this.$t('field.tax').toLowerCase()
          })
        )
      }
    },
    updateTax(value) {
      this.item.tax_id = value.id
    },
    getClassifications() {
      this.classifications = this.classificationDrugOptions
    },
    setClassification() {
      this.classification = this.item.classification
        ? this.classifications.find(
            item => item.label === this.item.classification
          )
        : null
    },
    updateClassification(value) {
      this.item.classification = value.label
    },
    getDosageForms() {
      this.dosageForms = this.dosageFormOptions
    },
    setDosageForm() {
      this.dosageForm = this.item.dosage_form
        ? this.dosageForms.find(item => item.label === this.item.dosage_form)
        : null
    },
    updateDosageForm(value) {
      this.item.dosage_form = value.label
    },
    formatPercentageWithSymbol(value) {
      return Math.round(value * Math.pow(10, 3) * 100) / Math.pow(10, 3) + '%'
    }
  }
}
</script>
